<template>
	<v-card 
		outlined 
		style = "
			width 		 : 100%; 
			height 		 : 100%; 
			object-fit 	 : fill;   
			border-color : grey "
	>
		<v-card-title 			
			class = "justify-center py-0 caption secondary vue-draggable-handle white--text" 
		>
			<v-spacer></v-spacer>
			<span 
				v-text="$ml.get('detected_faces')"
			></span>
			<v-spacer></v-spacer>
			<v-btn 
				x-small 
				outlined 
				icon 
				class  = "error"
	          	@click = "$emit('close_component', layout_id)"
	          	v-show = "show.close"          
	        >
	        <v-icon 
	          	x-small 
	          	outlined
	          	color  = "white" 
	          	class  = "ml-0" 
	          	v-text = "'mdi-close'"
	        ></v-icon>
	      </v-btn>	
		</v-card-title>
		<v-divider></v-divider>
		<v-card-text 
			class = "pa-0 no-drag"
			style = "width:100%; height:100%; object-fit: fill;" 
			ref   = "card_select_face"
		>
				<v-item-group>
					<v-container 
						fluid class = "pt-0 overflow-y-auto"  
						id 			= "scroll-target"  
						:style 		= "{ height:height_select + 'px', overflowX: 'hidden' }" 
					> <!-- 400 -->
						<v-row 
							v-scroll:#scroll-target="onScroll" 
							:style="{ height: height_select + 'px' }" 
							dense
						>
							<v-col 
								v-for 	= "n in list.slice().reverse()" 
								:key 	= "n.id" 
								@click  = "sel(n)" 
								cols 	= "auto" 
								lg 		= "auto" 
								md 		= "auto" 
								sm 		= "auto" 
								xl 		= "auto" 
								style 	= "justify: center;"
							>
								<!-- class 	= "pa-1 ma-0"  -->
								<v-item v-slot:default="{ active, toggle}" >
									<v-card 
										:color 	= "active ? 'primary' : '' "  
										dark  
										style  	= "width:70px"  
										class 	= "pa-1 ma-0"  
										@click 	= "toggle" 
										outlined
									>
										<!-- class="d-flex align-center" -->
										  <v-scroll-y-transition>
							                  
							                  	<!-- display-3 flex-grow-1 caption align-center -->
							                   <!-- 'http://localhost:8004'+n.url_photo -->
												<v-img  
													:src="n.thumbnail" 
													@error="n.thumbnail = '/img/no_img_found.png'"
													width="70" 
													height="64"
												></v-img>

												
							                 
							                   	<!-- display-3 flex-grow-1 caption align-center -->
							               	
							                    <!-- <v-img src="@/assets/logo.png"></v-img> -->
												<!-- <v-img  :src="'http://localhost:8004'+n.url_photo" width="48" height="64"></v-img> 
												width="48" height="64"
												-->
											
							                </v-scroll-y-transition>
							                <v-divider></v-divider>
							                <p 
							                	class="pa-0 ma-0" 
							                	style="font-size: 60%; line-height: 130%"

							                >
							            		{{n.timestamp}}
							            	</p> <!-- 54% -->
									</v-card>
								</v-item>
							</v-col>
						</v-row>	
					</v-container>
					<show_face 
						:info_to_component   = "item" 
						v-on:close 			 = "close_dialog($event)"
					></show_face>
				</v-item-group>
			
				<!-- <v-img  v-bind:src="'http://186.144.34.154:8004'+n" width="10%" ></v-img> -->
			<!-- v-on:change_page="page_select=$event" -->
			<v-bottom-navigation
				height="40"
		 		dense
		 	>
				<v-btn text :disabled="true">
			    <span>
					{{ $ml.get('number_items') }}:
			    	{{pagination_select.items}}
			    </span>
				</v-btn>				    
				
		     		<!-- class="col-md-4" -->
		     	<v-pagination
				    dense
			      	v-model 		= "page_select"					 
				    :length 		= "pagination_select.total"
				    :total-visible 	= "pagination_select.visible"
			    ></v-pagination>					
			</v-bottom-navigation>
		</v-card-text>
	</v-card>
<!-- <show_face :select="select"></show_face> -->

</template>
<script>
import show_face 	from '@/components/face/show_face.vue';
import axios 		from 'axios'
import io 			from 'socket.io-client';
import moment 		from 'moment-timezone';
import EventBus 	from '@/event-bus'
// moment().format();
// import cors from 'cors';
// app.use(cors())
// const Websocket = require('ws');
// import Websocket from 'websocket'

	export default{
		name: 'select_face',
		components: { 
			show_face , 
			io, 
			moment
		}, // components
		props:[
			'layout',
			'layout_id'
		],
		data() {
      		return {
        		select 				: '',
				offsetTop 			: 0,
				faces 				: [],
				faces_last 			: [],
				item 				: [],
				pagination_select 	: {
					visible : 5,
					total 	: 0,			
					items 	: 0,
					found 	: true,
					
				},
				page_select 	: 1,			
				height_select 	: 0,
				list_devices 	: [],
				list_uuids 		: [],
				show 			: {
					close : true,
				}
				
      		};
      	},
      	created() {
      		// this.list_faces();
      		if (!this.$Helper.current_auth_user(this.currentUser, {roles : [1, 2]})) {
      			this.show.close = false;
      		}
			

      	},
      	watch:{
      		paginate_select: function(pg){
      			this.list_faces(pg);
      		}, //paginate_select

      		layout: function(val){
      			if (val){
      				this.onResize();
      			}
      		}, // layout
      		page_select: function(val){
      			this.list_faces(val);      			
      		},

      	}, // watch
      	/**	
		data: ()=>({
			select: '',
			offsetTop: 0,
			faces:[],
			n:'/media/uploads/tracker/0/thumbnail/2e509172-af3.jpg'

		}),**/
		methods:{
			onScroll (e) {
        		this.offsetTop = e.target.scrollTop
      		},
      		sel(v){
      			this.item = v;
      			//console.log(this.item, v, 'id_tracker')
      		}, // sel

      		close_dialog(v){
	      		this.item = v;
      		},// close_dialog

      		list_faces(pag = 1){ //get faces 
      			axios.defaults.withCredentials = true;
      			// _face
      			const api = this.$URL + "/api/v1/face/?page=" + pag;//`` // ?=page '/api/face/listfaces/
      			// console.log("page select : ", pag);
      			this.faces_last = [];
      			this.faces 		= [];
      			axios.get(api).then(response => {
      				//console.log(response.data.results)

      				let items 		= response.data.results
      				let item 		= response.data;
      				item.number 	= item.results.length;
      				let pags 		= item.count / 30; // 
      				// console.log("pages : ", item)
      				let decimal 	= "";
      				// console.log( "decimal   ", (pags+"").split(".") , pags, item.count)
      				if ((pags + "").split(".").length > 0) {
      					decimal 	= (pags+"").split(".")[1];
      					if (decimal > 5) {
      						pags 	= parseInt(pags + 1);
      					}else{
      						pags 	= parseInt(pags)
      					}
      				}

      				let vm 		= this;
      				item.pages 	= pags;
      				items.forEach(function (arr_face, idx_face){
      					if (arr_face && arr_face.host_id) {
      						arr_face.device = vm.render_device(arr_face.host_id);
      					}
  					});
  					const timer = setTimeout(()=>{

  						this.faces_last = items;
  					}, 50);

      				this.pagination_select = {
      					visible: 5,
						total: item.pages,			
						items: item.number,
						found: true,
      				}
      				// this.$emit('change_pagination', to_paginate);

      		}).catch(error => {
      			console.log(error, 'error selected face')
        		this.errorMsg = 'No user or no location!'
        		this.data = []
      		})

      		},// list faces

      		

      		onResize() {				
								
				if (this.$refs.card_select_face ) {
					this.height_select = this.$refs.card_select_face.clientHeight - 63; // 60
				}

				// console.log( this.$refs.card_select.clientHeight, this.height_select,'height recognized face');
			}, //on Resize

			render_device(val){
				let vm 	   = this,
					device = ''	;
				if (vm.list_devices && vm.list_devices.length > 0) {

					const find = vm.list_devices.some(function(dev, idx_dev) {
						if (dev.deviceId == val) {
							device = dev.name;
							return true
						}
					}) 

					return device;
				}
				return '';
			}, // render_device
			addOrUpdateData(newData) {
				const existingIndex = vm.faces.findIndex(item => item.tracker_id === newData.tracker_id);
				
				if (existingIndex !== -1) {
					// Si ya existe, actualizamos el objeto
					console.log("Si ya existe, actualizamos el objeto")
					vm.faces[existingIndex] = {...vm.faces[existingIndex], ...newData};
				} else {
					// Si no existe, lo agregamos al array
					
					vm.faces.push(newData);
				}
			}//addOrUpdateData

		},
		computed:{
			list: function(){
				let socket 	= this.faces;
				let lasts 	= this.faces_last;
				let list 	= []; //				
				let numberA = parseInt("1585054543788", 10);
				
				let test 	={
	            "id_tracker": 123,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "timestamp" : moment(parseInt("1585054543788", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	          
	            let test1={

	            "id_tracker": 124,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "timestamp":  moment(parseInt("1585054744715", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	           
	           // list.push(test1);
	            let test2={

	            "id_tracker": 125,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "timestamp":  moment(parseInt("1585054944715", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	          
	            let test3={

	            "id_tracker": 126,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "host_id" : "e3cddf03-4481-4e68-b0eb-48a44ef66cee",
	            "timestamp":  moment(parseInt("1585058544715", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	            	// test3.device = this.render_device(test3.host_id);
	             // list.push(test3);
	             // list.push(test2);
	             // list.push(test1);
	             // list.push(test);
	            // list.reverse();

	         
	           // list.reverse();
           
				for(let i of lasts){ // lasts.length - 1; i >= 0; i-- / last thumbnail axios
					let list_l={
						'thumbnail':i.thumbnail,
						'id_tracker':i.id,
						'folder_path':i.folder_path,
						'device'		: i.device,
						'host_id' : i.host_id,
						'array_device_id' 		: this.list_uuids,
						'timestamp': moment(parseInt(i.timestamp, 10)).tz('America/Bogota').format('ll, LTS'),

					}
					list.push(list_l);
				}
				for (let i of socket){ // new thumbnail socket{
					// if (i.prediction=="") {
						let list_n={
							'thumbnail': this.$URL_face + i.url_photo,
							'id_tracker': i.id_tracker,
							'folder_path': i.folder_path,
							'device'		: i.device,
							'host_id' 		: i.host_id,
							'array_device_id' 		: this.list_uuids,
							'timestamp': moment(parseInt(i.timestamp, 10)).tz('America/Bogota').format('ll, LTS'),
						}// let
						list.push(list_n)
					// } //if
				}//for
				
				// list.sort(function(a,b){
				// 	  // Turn your strings into dates, and then subtract them
				// 	  // to get a value that is either negative, positive, or zero.
				// 	  return new Date(b.timestamp) - new Date(a.timestamp);
				// 	});

				//list.reverse()
				
				/*for(let i ; i<31; i++){					
					if (list.length>29){
						list.shift()
						console.log(list.length, 'list')
					}
				}*/

				return list;
			},//list


  //  reverseItems() {
  //       return this.items.slice().reverse();
  // }  


			// link(){
			// 	var l;
			// 	return l="http://186.144.34.154:8004/media/uploads/tracker/0/thumbnail/2e509172-af3.jpg"
			// }

			currentUser(){
		      return this.$store.state.auth.user;
		    }, // currentUser
		},
		mounted(){ 
			this.list_faces();
			let arr = []

			this.$nextTick( ()=>{
				this.onResize();
			});
			
      		let  vm = this;
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
				let list_temp = [];
				vm.list_devices.forEach(function(arr_dev){
					if (arr_dev.deviceId) {

						list_temp.push(arr_dev.deviceId); 
					}
				})
				this.list_uuids = list_temp;
			}

      		// var data={}
      		// const socket = new  WebSocket("ws://" + this.$localhost+':'+this.$port_face+ "/ws/events");

      		// console.log(socket, 'ofice')
      		// socket.onmessage = function (e) { 
			EventBus.$on('events_face', (msg)=>{
				console.log("llegando aqui")			

				/*if (msg && msg.host_id) {
					msg.device = vm.render_device(msg.host_id);
				}*/
				addOrUpdateData(msg)

				
				if (vm.faces.length > 29){
					vm.faces.shift()					
				}


			})
			// }


		} //export
	}
</script>